"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const platform_browser_1 = require("@angular/platform-browser");
const forms_1 = require("@angular/forms");
const http_1 = require("@angular/http");
const plc_component_1 = require("./plc/plc.component");
const plc_1 = require("../../plc/src/plc");
const inaxSignalR_1 = require("../../common/src/signalR/inaxSignalR");
const clipboard_directive_1 = require("./directives/clipboard/clipboard.directive");
const plc_textbox_component_1 = require("./plcTextbox/plc-textbox.component");
const plc_button_component_1 = require("./plcButton/plc-button.component");
const plc_checkbox_component_1 = require("./plcCheckbox/plc-checkbox.component");
const plc_radio_component_1 = require("./plcRadio/plc-radio.component");
const plc_state_component_1 = require("./plcState/plc-state.component");
let PlcUiModule = class PlcUiModule {
    constructor() { }
};
PlcUiModule = __decorate([
    core_1.NgModule({
        imports: [
            //Modules
            platform_browser_1.BrowserModule,
            forms_1.FormsModule,
            http_1.HttpModule
        ],
        exports: [
            plc_component_1.PlcComponent,
            plc_textbox_component_1.PlcTextboxComponent,
            plc_button_component_1.PlcButtonComponent,
            plc_checkbox_component_1.PlcCheckboxComponent,
            plc_radio_component_1.PlcRadioComponent,
            plc_state_component_1.PlcStateComponent
        ],
        declarations: [
            //Components
            plc_component_1.PlcComponent,
            plc_textbox_component_1.PlcTextboxComponent,
            plc_button_component_1.PlcButtonComponent,
            plc_checkbox_component_1.PlcCheckboxComponent,
            plc_radio_component_1.PlcRadioComponent,
            plc_state_component_1.PlcStateComponent,
            clipboard_directive_1.ClipboardDirective
        ],
        providers: [
            plc_1.InaxPlcService,
            inaxSignalR_1.InaxSignalR
        ],
        bootstrap: []
    }),
    __metadata("design:paramtypes", [])
], PlcUiModule);
exports.PlcUiModule = PlcUiModule;
